import React, { useMemo } from 'react';
import { Select } from 'antd';
import type { ChatRecipientOption } from './useChatRecipientDirectory';
import styles from './ChatPanel.module.css';

export interface RecipientPickerProps {
  options: ChatRecipientOption[];
  value: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
}

function toSelectOption(opt: ChatRecipientOption) {
  return {
    value: opt.value,
    label: opt.label,
    title: opt.subtitle ? `${opt.label} (${opt.subtitle})` : opt.label,
  };
}

export const RecipientPicker: React.FC<RecipientPickerProps> = ({
  options,
  value,
  onChange,
  disabled = false,
}) => {
  const grouped = useMemo(() => {
    const people = options.filter((opt) => opt.kind === 'person').map(toSelectOption);
    const agents = options.filter((opt) => opt.kind === 'agent').map(toSelectOption);
    const groups = [];
    if (people.length > 0) {
      groups.push({ label: 'People', options: people });
    }
    if (agents.length > 0) {
      groups.push({ label: 'Agents', options: agents });
    }
    return groups;
  }, [options]);

  return (
    <Select
      mode="multiple"
      allowClear
      showSearch
      disabled={disabled}
      placeholder="Type to find people or agents…"
      className={styles.recipientSelect}
      value={value}
      onChange={(next) => onChange(next as string[])}
      optionFilterProp="label"
      options={grouped}
      maxTagCount="responsive"
    />
  );
};
